// extracted by mini-css-extract-plugin
export default {"firstMainBodySection":"styles_firstMainBodySection__TlByi"};